import styled from "styled-components";
import { IconPoint } from "../icon/IconPoint";
import { IconTicket } from "../icon/IconTicket";

interface IProps {
    title?: string;
    imgmission?: string;
    point?: number;
    ticket?: number;
    textButton?: string;
    active?: boolean;
    onClick?: () => void;
}

export const SpinBenefit = (props: IProps & { onClick?: () => void }) => {
    return (
        <StyledSpinBenefit>
            <div className="img-spin-mission"><img src={props.imgmission || ""} alt="" /></div>
            <h2>{props?.title || "Title"}</h2>
            <div className="iconpoint">
                <span><IconPoint /></span> + {props.point || "XX"} Points =  <span className="ticket"><IconTicket /></span> {props.ticket || "XX"} Ticket
            </div>
            <StyledBtnSpinBenefit active={props.active} onClick={props.onClick}>
                {props.textButton || "Redeem"}
            </StyledBtnSpinBenefit>
        </StyledSpinBenefit>
    );
};


const StyledBtnSpinBenefit = styled.button<{ active?: boolean }>`
    font-size: 12px;
    line-height: 15px;
    font-weight: 600;
    padding: 10px 12px;
    border-radius: 12px;
    background-color: ${({ active }) => (active ? 'transparent' : '#ffe212')};
    color: ${({ active }) => (active ? '#999' : '#000')};
    border: ${({ active }) => (active ? '1px solid #999' : 'none')};
    text-align:center;
    position: absolute;
    right: 0;
    top: 0;
`;

const StyledSpinBenefit = styled.div`
    position: relative;
    padding-left:60px;
    padding-right: 75px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ddd;
    .img-spin-mission {
        position: absolute;
        width: 45px;
        height: 45px;
        border-radius: 16px;
        left: 0;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    h2 {
        font-size: 14px;
        line-height: 17px;
        font-weight: 600;
        margin-bottom: 5px;
        color: #000;
    }
    .iconpoint {
        display: flex;
        align-items: center;
        font-size: 10px;
        line-height: 13px;
        color: #000;
        span {
            margin-right: 5px;
        }
        span.ticket {
            margin-left: 5px;
        }
    }
    
`;